export const navCompanyData = [
  'home',
  'campaign',
  // 'cv',
  'staff',
  // 'report',
  'setting',
];

export const navAdminData = ['admin-home', 'admin-user'];
